import { alpha, useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import * as Preact from 'preact';
import { setContrastColour } from './domain/colour/colourChecks';
import { imageValue, swatchValue } from './domain/propertyOption/option';
import { WarningChange } from './icons/warningChange';
export var Component = function (p) {
    var theme = useTheme();
    return (p.colour && (Preact.h(IconButton, { onClick: function () { return p.onClick(p.colour); }, disabled: p.active, disableRipple: true, sx: {
            width: '40px',
            height: '40px',
            outline: p.active
                ? "2px solid ".concat(theme.palette.primary.main)
                : "1px solid ".concat(alpha(theme.palette.primary.main, 0.15)),
            border: '2px solid white',
            borderRadius: '8px',
            padding: '2px',
            backgroundClip: 'content-box',
            background: "no-repeat center url('".concat(imageValue(p.colour), "')"),
            backgroundSize: 'auto 100%',
            backgroundColor: swatchValue(p.colour),
            transition: 'outline .1s ease-in-out',
            '&:hover': {
                background: "no-repeat center url('".concat(imageValue(p.colour), "')"),
                backgroundSize: 'auto 100%',
                backgroundColor: swatchValue(p.colour),
                outline: p.active
                    ? '1ps solid transparent'
                    : "2px solid  ".concat(alpha(theme.palette.primary.main, 0.25)),
            },
            '&.Mui-disabled': {
                background: "no-repeat center url('".concat(imageValue(p.colour), "')"),
                backgroundSize: 'auto 100%',
                backgroundColor: swatchValue(p.colour),
                color: swatchValue(p.colour),
            },
        } }, p.incompatible && !p.active && (Preact.h(WarningChange, { sx: {
            color: setContrastColour(swatchValue(p.colour)),
            opacity: '35%',
        } })))));
};
Component.displayName = 'ColourSelector';
